import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const StyledButton = styled(Button)(({ theme }) => ({
    height: '40px',
    border: `1px solid ${theme.palette.divider}`,
    background: 'none',
    borderRadius: '16px',
    ':hover': {
        backgroundColor: theme.palette.action.hover,
    },
    ':active': {
        backgroundColor: theme.palette.action.hover,
    },
    marginLeft: '8px',
}));

export const NavContainer = styled(Stack)(() => ({
    flexDirection: 'row',
    alignItems: 'center',
    'button:last-child': {
        marginLeft: '8px',
    },
}));

export const HeaderButtonsStack = styled(Stack)(() => ({
    justifyContent: 'center',
    alignItems: 'center',
    my: 2,
    ml: 1,
}));

export const StyledBox = styled(Box)(({ theme }) => ({
    border: 'none',
    height: '100%',
    whiteSpace: 'nowrap',
    '& .carousel': {
        marginLeft: 5,
        '&__slide': {
            display: 'block',
        },
    },
    '.swiper': {
        paddingBottom: '4px',
    },
    '.swiper-slide': {
        [theme.breakpoints.up('md')]: {
            width: 'calc((100% - (4 * 12px)) / 5)',
        },
        [theme.breakpoints.down('md')]: {
            width: '165px',
        },
    },
}));
